angular.module('storefrontApp')
    .component('vcCustomerReviewsRating', {
        templateUrl: 'themes/assets/js/common-components/vcCustomerReviewsRating.tpl.html',
        bindings: {
            storeid: '@',
            productid: '@',
            number: '=',
        },
        controller: ['vcCustomerReviewsRatingService', function (ratingService) {
            const ctrl = this;

            ctrl.stars = [false, false, false, false, false];
            ctrl.half = [false, false, false, false, false];

            this.$onInit = function () {
                ctrl.rating = 0;

                if (ctrl.number) {
                    ctrl.rating = ctrl.number;
                    fillStars();
                } else {
                    ratingService.getRating(ctrl.storeid, ctrl.productid)
                        .then(function (response) {
                            const ratings = response.data;

                            if (ratings.length === 1) {
                                ctrl.rating = ratings[0].value;
                                fillStars();
                            }
                        });
                }
            };

            function fillStars() {
                ctrl.stars.forEach((element) => { // eslint-disable-line no-unused-vars
                    element = false;
                });

                ctrl.half.forEach((element) => { // eslint-disable-line no-unused-vars
                    element = false;
                });

                const floor = Math.floor(ctrl.rating);
                const rest = ctrl.rating - floor;

                for (let i = 0; i < floor; i += 1) {
                    ctrl.stars[i] = true;
                }

                if (rest >= 0.2 && rest < 0.7) {
                    ctrl.half[floor] = true;
                }

                if (rest >= 0.7) {
                    ctrl.stars[floor] = true;
                }
            }

            this.$onDestroy = function () {};
        }],
    });
